<template>
  <div id="staff-block-time" class="rounded relative overflow-hidden vs-con-loading__container rounded-item">
    <vs-sidebar
        class="items-no-padding"
        parent="#staff-block-time"
        :click-not-close="clickNotClose"
        :hidden-background="clickNotClose"
        v-model="active"
        id="staff-block-time-sidebar"
      >
      <div style="height: calc(100% - 50px); overflow: auto;">
        <div class="staff__staffs-list mb-4">
          <ul class="staff__active-staffs bordered-items">
            <li
              class="cursor-pointer border-0"
              v-for="(staff, index) in staffsList"
              :key="index"
              @click="updateActiveStaff(staff)"
            >
              <staff-item :staffData="staff" :isActive="isActive(staff.user_id)" :fromStaffBlockTime="true"></staff-item>
            </li>
          </ul>
        </div>
      </div>
      <div v-if="staffsData._meta.pageCount">
        <custom-pagination class="custom-pagination" :totalPages="parseInt(staffsData._meta.pageCount)" :currentPage="currentPage" @pageChanged="changePage" :key="'staff-pag-' + page_key"></custom-pagination>
      </div>
    </vs-sidebar>
    <div class="staff__bg app-fixed-height staff-content-area overflow-auto rounded-item">
      <div id="block-time-list" style="border-top-right-radius: 8px; border-bottom-right-radius: 8px;">
        <div :key="staff_key" class="p-4 flex flex-col justify-between h-full overflow-auto right-content" v-if="!isEmptyList">
          <div class="flex" style="width: inherit;">
            <div class="avatar-container">
              <vs-avatar
                :src="activeStaffData.image_url"
                class="border-2 border-solid border-white text-4xl"
                size="70px"
                :text="StringHelper.changeFormatAvatar(activeStaffData.name)"
                :color="activeStaffData.color_code"
              ></vs-avatar>
            </div>
            <div class="w-full pl-4" style="width: calc(100% - 80px) !important;">
              <div class="flex justify-between align-center pr-4">
                <p class="text-2xl py-3 font-bold color-black">
                  Time Off for {{activeStaffData.name}}:
                </p>
                <vs-button style="width: 35px; height: 35px; min-width: 35px; padding: 0; display: flex; align-items: center; justify-content: center;"
                  v-if="staffBlockTimeList.items && staffBlockTimeList.items.length > 0"
                  @click="addTimeOff(activeStaffData)"
                  >
                  <feather-icon icon="PlusIcon" svgClasses="h-5 w-5 stroke-current" style="transform: translateY(3px)" />
                </vs-button>
              </div>
              <!-- <div class="border-bottom-custom mb-base">
                <div v-for="i in 9" :key="i">
                  <div class="block-time border-top-custom p-4 cursor-pointer">
                    <div class="flex w-2/3 pr-4">
                      <div class="my-clock-icon">
                        <feather-icon icon="ClockIcon" svgClasses="h-4 w-4 stroke-current text-primary" />
                      </div>
                      <div class="day-distance-container">
                        <p class="day-distance pb-1">May 15, 2020 to May 23, 2020</p>
                        <p class="description text-sm text-grey-custom">Holiday</p>
                      </div>
                    </div>
                    <div class="flex text-grey-custom text-sm w-1/3">
                      <p class="mr-4 w-1/2">Every 1 Week</p>
                      <p class="w-1/2">8:00 am to 5:00 pm</p>
                    </div>
                  </div>

                  <div class="block-time border-top-custom p-4 cursor-pointer">
                    <div class="flex w-2/3 pr-4">
                      <div class="my-clock-icon">
                        <feather-icon icon="CalendarIcon" svgClasses="h-4 w-4 stroke-current text-primary" />
                      </div>
                      <div class="day-distance-container">
                        <p class="day-distance pb-1">Aug 3, 2018</p>
                        <p class="description text-sm text-grey-custom">No Description</p>
                      </div>
                    </div>
                    <div class="flex text-grey-custom text-sm w-1/3">
                      <p class="mr-4 w-1/2">No repeat</p>
                      <p class="w-1/2">Allday</p>
                    </div>
                  </div>
                </div>
              </div> -->

              <div class="border-bottom-custom mb-6" v-if="staffBlockTimeList && staffBlockTimeList.items">
                <div v-for="(staff, index) in staffBlockTimeList.items" :key="index" @click="updateTimeOff(staff)">
                  <div class="flex block-time border-top-custom p-4 cursor-pointer" v-if="staff.all_day != 1">
                    <div class="flex w-1/2 pr-4">
                      <div class="my-clock-icon">
                        <feather-icon icon="ClockIcon" svgClasses="h-4 w-4 stroke-current text-primary" />
                      </div>
                      <div class="day-distance-container">
                        <p class="day-distance pb-1">{{getFormatDate(staff.start_date)}}<span v-if="getFormatDate(staff.start_date) != getFormatDate(staff.end_date)"> to {{getFormatDate(staff.end_date)}}</span></p>
                        <p class="description text-sm text-grey-custom" v-if="staff.description == ''">No Description</p>
                        <p class="description text-sm text-grey-custom" v-else>{{staff.description}}</p>
                      </div>
                    </div>
                    <div class="flex text-grey-custom text-sm w-1/2">
                      <p class="mr-4 w-1/3 flex-center text-center" v-if="staff.data && staff.recurring == '1'">
                        Every
                        <span v-if="staff.data.recurring_type == 'monthly'">Month</span>
                        <span v-else>Week</span>
                      </p>
                      <p class="mr-4 w-1/3 flex-center text-center" v-else>No repeat</p>
                      <p class="mr-4 w-5/12 flex-center text-center">{{getFormatTime(staff.start_date)}} to {{getFormatTime(staff.end_date)}}</p>
                      <div class="w-1/4 flex justify-end my-auto">
                        <!-- <vs-button color="orange" style="width: 35px; height: 35px; min-width: 35px; padding: 0; display: flex; align-items: center; justify-content: center;" @click.stop="openDeletePopup(staff)">
                          <feather-icon icon="TrashIcon" svgClasses="h-4 w-4 stroke-current" style="transform: translateY(3px)"/>
                        </vs-button> -->
                        <img src="../../assets/images/trash-icon.png" class="trash-icon mx-3" @click.stop="openDeletePopup(staff)" />
                      </div>
                    </div>
                  </div>

                  <div class="flex block-time border-top-custom p-4 cursor-pointer" v-else>
                    <div class="flex w-1/2 pr-4">
                      <div class="my-clock-icon">
                        <feather-icon icon="CalendarIcon" svgClasses="h-4 w-4 stroke-current text-primary" />
                      </div>
                      <div class="day-distance-container">
                        <p class="day-distance pb-1">{{getFormatDate(staff.start_date)}}</p>
                        <p class="description text-sm text-grey-custom" v-if="staff.description == ''">No Description</p>
                        <p class="description text-sm text-grey-custom" v-else>{{staff.description}}</p>
                      </div>
                    </div>
                    <div class="flex text-grey-custom text-sm w-1/2">
                      <p class="mr-4 w-1/3 flex-center text-center" v-if="staff.data && staff.recurring == '1'">
                        Every
                        <span v-if="staff.data.recurring_type == 'monthly'">Month</span>
                        <span v-else>Week</span>
                      </p>
                      <p class="mr-4 w-1/3 flex-center text-center" v-else>No repeat</p>
                      <p class="mr-4 w-5/12 flex-center text-center" v-if="staff.data && staff.recurring == '1'">Fullday</p>
                      <p class="mr-4 w-5/12 flex-center text-center" v-else>All day</p>

                      <div class="w-1/4 flex justify-end my-auto">
                        <!-- <vs-button color="orange" style="width: 35px; height: 35px; min-width: 35px; padding: 0; display: flex; align-items: center; justify-content: center;" @click.stop="openDeletePopup(staff)">
                          <feather-icon icon="TrashIcon" svgClasses="h-4 w-4 stroke-current" style="transform: translateY(3px)"/>
                        </vs-button> -->
                        <img src="../../assets/images/trash-icon.png" class="trash-icon mx-3" @click.stop="openDeletePopup(staff)" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="staffBlockTimeList.items && staffBlockTimeList.items.length == 0" class="border-custom p-6">
                <div class="flex flex-col align-center justify-center">
                  <h5 class="pb-6 text-center">Add time off by clicking the button below.</h5>
                  <vs-button color="primary" type="filled" icon="add_circle_outline" @click="addTimeOff(activeStaffData)">Add Time Off</vs-button>
                </div>
              </div>
            </div>
          </div>
          <div class="mt-auto" v-if="staffBlockTimeList && staffBlockTimeList.items && staffBlockTimeList.items.length > 0 && staffBlockTimeList._meta 
                                    && staffBlockTimeList._meta.pageCount && staffBlockTimeList._meta.pageCount > 1">
            <custom-pagination
              class="custom-pagination"
              :totalPages="parseInt(staffBlockTimeList._meta.pageCount)"
              :currentPage="bt_currentPage"
              @pageChanged="bt_changePage"
              :key="'bt-staff-pag-' + bt_page_key"
            ></custom-pagination>
          </div>
        </div>
        <div v-else class="p-4 flex h-full align-center justify-center">
          No data available
        </div>
      </div>
    </div>
    <vs-popup class="holamundo delete-block-time" title="Delete Block Time" :active.sync="popupActive">
      <div class="text-center">
        <h3>Do you want to delete this block time?</h3>
        <div class="flex flex-wrap items-center align-center p-6 justify-center">
          <vs-button class="mr-6 align-center delete-responsive" @click="deleteTimeOff">Delete</vs-button>
          <vs-button type="border" color="danger" class="cancel-responsive" @click="popupActive = false">Cancel</vs-button>
        </div>
      </div>
    </vs-popup>
    <add-time-off :activePromptAddEvent="activePromptAddEvent" :typeBlock="type" :staff="activeStaffData" :key="staff_key" :currentPage="bt_currentPage" :itemsPerpage="bt_itemsPerpage"></add-time-off>
    <update-time-off :activePromptUpdateEvent="activePromptUpdateEvent" :blockTimeData="blockTimeData" :currentPage="bt_currentPage" :itemsPerpage="bt_itemsPerpage"></update-time-off>
  </div>
</template>

<script>
import { StringHelper } from "../../models/string_helper";
import moment from 'moment'
export default {
  name: 'staff-block-time',
  data(){
    return{
      blockTimeData: {},
      activePromptUpdateEvent: {
        isOpen : false
      },
      activePromptAddEvent: {
        isOpen : false
      },
      type: 'staff',
      active: true,
      clickNotClose: true,
      currentPage: 1,
      activeStaff: null,
      activeStaffData: {},
      staff_key: 0,
      page_key: 0,
      StringHelper,
      staff : {},
      updateKey: 0,
      popupActive: false,
      action_type: '',
      isOpenLoading: false,
      loaded_data_num: 0,
      // hasList: false
      isEmptyList: false,
      bt_currentPage: 1,
      bt_itemsPerpage: 5,
      bt_page_key: 0
    }
  },
  watch: {
    loaded_data_num: {
      immediate: true,
      handler() {
        if(this.loaded_data_num >= 2 || this.isEmptyList) {
          this.closeLoading();
        } else {
          this.action_type = "Get data";
          this.openLoadingInDiv();
        }
      }
    }
  },
  methods: {
    openLoadingInDiv(){
      this.$vs.loading({
        container: '#app',
        scale: 0.8
      })
      if(this.loadTime){
        clearTimeout(this.loadTime);
        this.loadTime = null;
      }
      this.isOpenLoading = true;
      this.loadTime = setTimeout( ()=> {
        if(this.isOpenLoading) {
          this.closeLoading();
          this.$vs.dialog({
            color: 'danger',
            title: 'Notification',
            text: this.action_type + ' block time failed',
            acceptText: 'OK'
          })
        }
      }, 10000);
    },
    closeLoading() {
      this.$vs.loading.close('#app > .con-vs-loading');
      this.isOpenLoading = false;
    },
    bt_changePage(page) {
      const obj = {
        filterType : 2,
        filterStaffId: this.activeStaff,
        page: page,
        'per-page': this.bt_itemsPerpage
      }

      if(!this.isOpenLoading) {
        this.openLoadingInDiv();
      }
      this.action_type = 'Get list';
      this.$store.dispatch("business/LIST_STAFF_BLOCK_TIME", obj).then(() => {
        this.bt_currentPage = page;
        this.bt_page_key++;
        this.closeLoading();
      })
    },
    addTimeOff(data){
      this.action_type = 'Add';
      this.activePromptAddEvent.isOpen = true;
      this.staff = data;
    },
    getFormatTime(date){
      let stringTime = '';
      if(parseInt(date.slice(10,13)) < 12){
        if(parseInt(date.slice(10,13)) == 0){
          stringTime = String(parseInt(date.slice(10,13)) + 12) + date.slice(13,16) + ' am';
        }else{
          stringTime = String(parseInt(date.slice(10,13))) + date.slice(13,16) + ' am';
        }
      }else{
        if(parseInt(date.slice(10,13)) == 12){
          stringTime = String(parseInt(date.slice(10,13))) + date.slice(13,16) + ' pm';
        }else{
          stringTime = String(parseInt(date.slice(10,13)) - 12) + date.slice(13,16) + ' pm';
        }
      }
      return stringTime;
    },
    getFormatDate(date){
      return moment(date).format('LL');
    },
    updateActiveStaff(staff) {
      this.loaded_data_num = 1;
      this.bt_currentPage = 1;
      this.bt_page_key++;
      if(staff) {
        this.activeStaff = staff.user_id;
        this.activeStaffData = staff;
        this.staff_key++;

        const data = {
          filterType : 2,
          filterStaffId: staff.user_id,
          page: this.bt_currentPage,
          'per-page': this.bt_itemsPerpage
        }
        this.$store.dispatch("business/LIST_STAFF_BLOCK_TIME", data).then(() => {
          this.loaded_data_num++;
        });
      }
    },
    updateTimeOff(staff){
      this.action_type = 'Update';
      this.activePromptUpdateEvent.isOpen = true;
      this.blockTimeData = staff;
      this.updateKey++;
    },
    isActive(id) {
      return id == this.activeStaff;
    },
    changePage(currentPage) {
      const obj = {
          page: currentPage,
          "per-page": 10,
          sort: 'user_id'
      }
      this.openLoadingInDiv();
      this.$store.dispatch("staffList/GET_STAFF_LIST", obj).then(()=>{
        this.closeLoading();
        if(this.staffsList.length > 0) {
          this.updateActiveStaff(this.$store.getters["staffList/staffList"][0]);
        }
      })

      this.currentPage = currentPage;
      this.page_key++;
    },
    openDeletePopup(business) {
      this.blockTimeData = business;
      this.popupActive = true;
    },
    deleteTimeOff() {
      let isLastItem = false;
      if(this.staffBlockTimeList && this.staffBlockTimeList.items && this.staffBlockTimeList.items.length == 1) {
        isLastItem = true;
      }
      if(this.blockTimeData) {
        let obj = {
          id: this.blockTimeData.id,
          type: 2,
          staff_id: this.activeStaff,
          page: this.bt_currentPage,
          'per-page': this.bt_itemsPerpage
        }
        this.action_type = 'Delete';
        this.openLoadingInDiv();
        this.$store.dispatch('business/DELETE_BUSINESS_TIME_OFF', obj).then(() => {
          this.popupActive = false;
          if(isLastItem && this.bt_currentPage > 1) {
            this.bt_currentPage--;
          }
          this.closeLoading();
          this.$vs.notify({
            title:'Notification',
            text:'Delete Block Time Success',
            color:'success',
            position:'top-right'})
        }).catch(() => {
          this.popupActive = false;
          this.closeLoading();
          this.$vs.notify({
            title:'Notification',
            text:'Delete Block Time Failed',
            color:'danger',
            position:'top-right'})
        })
      }
    }
  },
  computed: {
    staffsList() {
      return this.$store.getters["staffList/staffList"];
    },
    staffsData() {
      return this.$store.getters["staffList/staffData"];
    },
    staffBlockTimeList() {
      return this.$store.getters["business/listStaffBlockTime"];
    }
  },
  created() {
    const obj = {
      page: this.currentPage,
      "per-page": 10,
      sort: 'user_id'
    }
    // if(this.status != 2) {
    //   obj.status = this.status;
    // }
    this.$store.dispatch("staffList/GET_STAFF_LIST", obj).then(() => {
      this.loaded_data_num++;
      if(this.$store.getters["staffList/staffList"].length != 0) {
        this.updateActiveStaff(this.$store.getters["staffList/staffList"][0]);
      } else {
        this.isEmptyList = true;
      }
    }).catch(error=>console.log(JSON.parse(error)));
  }
}
</script>
